import { Input } from 'antd';
import { FC } from 'react';
import { TextAreaProps } from 'antd/es/input';

const TextArea: FC<TextAreaProps> = ({ rows = 4, ...props }) => {
  return <Input.TextArea rows={rows} {...props} />;
};

export default TextArea;
